import Cookie, { removeSession } from "../utilities/CookieUtility";
import { Post } from "../utilities/AxiosUtility";
import { localPort, version } from "../utilities/Constants";

export default class System {
  static async Login(event) {
    let query = {};
    if (
      event.target.username.value.match("^[a-zA-Z0-9]*$") &&
      event.target.password.value.match("^[a-zA-Z0-9]*$")
    )
      query = {
        grant_type: "password",
        username: event.target.username.value,
        password: event.target.password.value,
        refresh_token: null,
        channel: "9",
      };
    Cookie.set(
      "auth",
      "18C6BE3EF2FDECCDE065228810C6777C323032343035313931323038353334303937333943686174626F74",
      { path: "/" }
    );
    const response = await Post(`${localPort}/${version}/ddish/login`, query);
    // console.log('%c 🍻 response: ', 'font-size:20px;background-color: #6EC1C2;color:#fff;', response)
    if (response && response.status === 200) {
      if (response.data.access_token) {
        localStorage.setItem("access_token", response.data.access_token);
        localStorage.setItem("refresh_token", response.data.refresh_token);
        localStorage.setItem("token_type", response.data.token_type);
        Cookie.set("auth", response.data.access_token, { path: "/" });
        response.data.result = "true";
        return response.data;
      }
    } else {
      throw "Нэвтрэлт амжилтгүй. Нэвтрэх мэдээллээ шалгана уу";
    }
  }
  static async Logout() {
    await Post("/api/queue", { type: "queueLogOut" });
    removeSession();
    localStorage.clear();
    window.location.reload();
  }
}
